export default __webpack_public_path__ + "static/media/water-icon.72386de0.svg";